import IconTooltip from './IconTooltip';
import SystemIconModifier, { type SystemIconProps } from './SystemIcon';

function DateIcon(props: SystemIconProps) {
  const { isSystem } = props;
  return (
    <IconTooltip isSystem={isSystem}>
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium fs-exclude"
        focusable="false"
        aria-hidden="true"
        data-testid="DateIcon"
        data-dd-action-name="FIM 3 Custom Field - icon redacted"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="4" fill="#E6B0A8" />
        <path
          d="M20.6667 6.49967H19.8334V4.83301H18.1667V6.49967H9.83342V4.83301H8.16675V6.49967H7.33341C6.41675 6.49967 5.66675 7.24967 5.66675 8.16634V21.4997C5.66675 22.4163 6.41675 23.1663 7.33341 23.1663H20.6667C21.5834 23.1663 22.3334 22.4163 22.3334 21.4997V8.16634C22.3334 7.24967 21.5834 6.49967 20.6667 6.49967ZM20.6667 21.4997H7.33341V12.333H20.6667V21.4997ZM20.6667 10.6663H7.33341V8.16634H20.6667V10.6663Z"
          fill="#995454"
        />
        {isSystem && SystemIconModifier()}
      </svg>
    </IconTooltip>
  );
}

export default DateIcon;
